module.exports = __webpack_public_path__ + "static/media/postman.72182c75.png";